import React from 'react';
import DefaultLayout from '../../../layout/DefaultLayout';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
import ProductSizeTable from '../../../components/Catalog/size/ProductSizeTable';

/**
 * 📏 ItemSizesPage
 *
 * Página para administrar tallas disponibles en productos.
 */
const ItemSizesPage: React.FC = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <ProductSizeTable />
    </DefaultLayout>
  );
};

export default ItemSizesPage;
